import template from './other-direct-costs-actuals.html';
import controller from './other-direct-costs-actuals.controller';

let otherDirectCostsActualsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default otherDirectCostsActualsComponent;



// WEBPACK FOOTER //
// ./client/pages/expenses/other-direct-costs-actuals/other-direct-costs-actuals.component.js